import { useCallback, useEffect, useMemo, useState } from 'react';

import isEqual from 'react-fast-compare';

export const useRequirementsChecklist = (requirementIds = []) => {
  const [requirementsChecklist, setRequirementsChecklist] = useState({});

  useEffect(() => {
    setRequirementsChecklist((prevChecklist) => {
      const updatedChecklist = requirementIds.reduce(
        (aggChecklist, requirementId) => ({
          ...aggChecklist,
          [requirementId]: prevChecklist[requirementId] ?? false,
        }),
        {},
      );

      return isEqual(prevChecklist, updatedChecklist) ? prevChecklist : updatedChecklist;
    });
  }, [requirementIds]);

  const updateRequirementStatus = useCallback(
    (requirementId, value) => {
      setRequirementsChecklist((prevState) => {
        if (prevState[requirementId] === value) {
          return prevState;
        }

        return {
          ...prevState,
          [requirementId]: value,
        };
      });
    },
    [setRequirementsChecklist],
  );

  const checklistCompleted = useMemo(() => {
    const isCompleted = Object.values(requirementsChecklist).every((requirement) => requirement);
    // if (!isCompleted) {
    //   // this is useful for debug
    //   const missingRequirements = Object.keys(requirementsChecklist).filter((requirement) => !requirementsChecklist[requirement]);
    //   console.log('Missing requirements:', missingRequirements);
    // }
    return isCompleted;
  }, [requirementsChecklist]);

  return { requirementsChecklist, updateRequirementStatus, checklistCompleted };
};
